import React from "react";

/**
 * <Brand /> — the canonical Clariva monogram.
 *
 * Used as the default fallback whenever a tenant doesn't have its own logo.
 * Renders the supplied PNG with a cream background disc by default, so the
 * mark keeps its intended contrast on both light and dark themes.
 */
export default function Brand({ size = 32, className = "", disc = true, testId }) {
  const dim = typeof size === "number" ? `${size}px` : size;
  return (
    <span
      data-testid={testId || "brand-mark"}
      className={`inline-flex items-center justify-center shrink-0 ${disc ? "rounded-md" : ""} ${className}`}
      style={{
        width: dim,
        height: dim,
        background: disc ? "#0B0D12" : "transparent",
        border: disc ? "1px solid var(--border-strong, #2a2d33)" : "none",
      }}
    >
      <img
        src="/clariva-logo.png"
        alt="Clariva"
        style={{ width: "72%", height: "72%", objectFit: "contain" }}
        draggable={false}
      />
    </span>
  );
}

export function BrandWordmark({ className = "", style = {} }) {
  return (
    <img
      src="/clariva-wordmark.png"
      alt="Clariva — AI Contract Intelligence"
      className={className}
      style={{ maxHeight: 140, width: "auto", ...style }}
      draggable={false}
    />
  );
}
